import React from 'react'
import { Col, Row, List, Avatar } from 'antd';
import koraSomosNosotros from '../../../src/images/koraSomosNosotros.png';
import koraSomosNosotrosBig from '../../../src/images/koraSomosNosotrosBig.png';
import koraSomosNosotrosSmall from '../../../src/images/koraSomosNosotrosSmall.png';
import activos from '../../../src/images/activos.png';
import calidad from '../../../src/images/calidad.png';
import natural from '../../../src/images/natural.png';
import servicio from '../../../src/images/servicio.png';
import { Img, ColCualidades, Title } from './styles';

export const SobreNosotros = () => {

    const dataCualidadades = [
        {
            title: 'Productos de alta calidad',
            description: (<ul>
                            <li>Nuestros productos son formulados y hechos en composiciones ricos en activos, 
                            ayudando que estos activos penetren en las capas más profundas de la piel, para 
                            que su efectividad sea mucho mayor.</li>
                            <li>Productos hipoalergénicos, tienen un riesgo mínimo de producir reacciones alérgicas a tu piel.</li>
                            <li>No son comedogénico, por lo que no obstruirán tus poros ni generarán imperfecciones.</li>
                            <li>Nos diferenciamos por formular nuestros productos con alto porcentajes de activos funcionales, lo que nos caracteriza poseer un producto de alta calidad en el mercado colombiano.</li>
                            <li>Garantizamos que obtendrás experiencias únicas lo que te hará elegir constantemente nuestros productos</li>
                        </ul>),
            imgName: 'activos',
            img: {activos},
        },
        {
            title: 'Productos naturales',
            description: (<ul>
                <li>Productos libres de parabenos ni otros tipos de químicos que puedan dañar tu piel.</li>
                <li>Nuestros productos son aptos para todo tipo de piel.</li>
                <li>No testeados con animales</li>
                <li>Nuestra formula están hechos con extractos y aceites naturales provenientes de plantas 100% naturales, siendo amigables con el medio ambiente</li>
            </ul>),
           imgName: 'natural',
           img: {natural},
        },
        {
            title: 'Mayor cantidad de activos en nuestros productos',
            description: (<ul>
                <li> Como política empresarial, tenemos como objetivo que nuestros productos sean de alta 
                calidad, para ello garantizamos el incremento de activos tanto en porcentaje como en 
                otras especies de activos. Nuestros productos poseen al menos mínimo 15 activos que 
                ayudaran a que tú piel o zona de interés salga a relucir.</li>
            </ul>),
           imgName: 'calidad',
           img: {calidad},
        },
        {
            title: 'Excelente servicio al cliente',
            description: (<ul>
                <li>Ofrecemos atención personalizada.</li>
                <li>Buena atención al cliente.</li>
                <li>Asesoramos a nuestros clientes.</li>
                <li>Respondemos por las quejas, reclamos y sugerencias generadas por los clientes.</li>
                <li>Cumplimos con el tiempo de entrega según el tiempo establecido</li>
                <li>Alta calidad del producto.</li>
            </ul>),
            imgName: 'servicio',
            img: {servicio},
        },
      ];

    return (
        <div className='divMarginContent'>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Img alt="koraHead" srcMedium={koraSomosNosotros} srcSmall={koraSomosNosotrosSmall} srcBig={koraSomosNosotrosBig} />
                </Col>
            </Row>
            <Row gutter={[16, 16]}>
                <Col span={12} style={{textAlign: 'justify'}} xs={{ span: 24 }} sm={{ span: 12 }}>
                    <Title>¿Quienes Somos?</Title>
                    <p>En Kôra Cosmetics promovemos una experiencia en el que nuestros valores de belleza van 
                        alienados con nuestro estilo de vida. Somos amantes del cuidado de la belleza reflejado
                        en los productos que elaboramos.</p>
                    <p>Nos caracterizamos por ofrecer productos elaborados con activos naturales que harán 
                        que tu piel se vea reluciente, seleccionados de los mejores extractos vegetales. Los 
                        productos Kôra fueron formulados con altos porcentajes de estos activos para llevarlos a 
                        una experiencia única con resultados que harán que tú belleza resalte.</p>
                </Col>
                <ColCualidades span={10} xs={{ span: 24 }} sm={{ span: 10 }}>
                    <Title>Nos diferenciamos de otras marcas por</Title>
                    <List
                        itemLayout="horizontal"
                        dataSource={dataCualidadades}
                        renderItem={item => (
                        <List.Item>
                            <List.Item.Meta
                            avatar={<Avatar src={item.img[item.imgName]} style={{marginRight: '5px'}}/>}
                            title={<a>{item.title}</a>}
                            description={item.description}
                            />
                        </List.Item>
                        )}
                    />
                </ColCualidades>
            </Row>
        </div>
    )
  }